import { LinkOutlined, LogoutOutlined, MoonOutlined, ProfileOutlined, SettingOutlined, SunOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Space, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { formatWalletAddress } from '../utils/walletUtils';

const { Text } = Typography;

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isWalletUser = !!user?.walletAddress;

  const items: MenuProps['items'] = [
    {
      key: 'info',
      label: (
        <div style={{ padding: '4px 0', minWidth: 200 }}>
          <Text strong>{isWalletUser ? 'Wallet' : user?.username}</Text>
          {user?.email && !isWalletUser && (
            <div>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {user.email}
              </Text>
            </div>
          )}
          {user?.walletAddress && (
            <div>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {formatWalletAddress(user.walletAddress)}
              </Text>
            </div>
          )}
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'profile',
      icon: <ProfileOutlined />,
      label: 'Profile',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'referral',
      icon: <LinkOutlined />,
      label: 'Referrals',
      onClick: () => navigate('/referral'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Auto Tab Opening Settings',
      onClick: () => navigate('/settings'),
    },
    {
      type: 'divider',
    },
    {
      key: 'theme',
      icon: theme === 'dark' ? <SunOutlined /> : <MoonOutlined />,
      label: theme === 'dark' ? 'Light Mode' : 'Dark Mode',
      onClick: toggleTheme,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  const displayName = isWalletUser
    ? `Wallet: ${user?.walletAddress ? formatWalletAddress(user.walletAddress) : ''}`
    : user?.email || user?.username || 'User';

  return (
    <Dropdown
      menu={{ items, style: { minWidth: 200 } }}
      placement="bottomRight"
    >
      <Button type="text" icon={isWalletUser ? <WalletOutlined /> : <UserOutlined />}>
        <Space>
          <Text style={{ maxWidth: 200 }} ellipsis>
            {displayName}
          </Text>
        </Space>
      </Button>
    </Dropdown>
  );
};

export default UserMenu;
